<template>
  <div>
    <b-card no-body class="mb-1">
      <b-card-header header-tag="header" class="p-1" role="tab">
        <p class="filterName subTitleContracts">Filtros</p>
        <b-button v-b-toggle.accordion-1 class="filterToggleBtn">{{filterAccordionBtnText}}</b-button>
      </b-card-header>
      <b-collapse id="accordion-1" v-model="filterVisible" accordion="my-accordion" role="tabpanel" class="filterBox">
        <b-card-body>
          <b-col cols="12">
            <b-row>
              <b-col cols="12" sm="6" md="4" lg="4" xl="4">
                <b-row>
                  <b-col cols="6">
                    <p>Nº Necesidad:</p>
                  </b-col>
                  <b-col cols="6">
                    <b-form-input id="filter-contract" type="text" v-model="filters.number_need" label="Nº Necesidad"/>
                  </b-col>
                </b-row>
              </b-col>
              <b-col cols="12" sm="6" md="4" lg="4" xl="4">
                <b-row>
                  <b-col cols="6">
                    <p>Fecha registro inicio:</p>
                  </b-col>
                  <b-col cols="6">
                    <b-form-datepicker id="filter-creation-init-date" class="form-control selectStatusInFilter" :max="contractMinEndDate"
                    name="createInit" placeholder="Selecciona una fecha" v-model="filters.start_fecha_reg" />
                  </b-col>
                </b-row>
              </b-col>
              <b-col cols="12" sm="6" md="4" lg="4" xl="4">
                <b-row>
                  <b-col cols="6">
                      <p>Fecha registro fin:</p>
                  </b-col>
                  <b-col cols="6">
                    <b-form-datepicker id="filter-creation-end-date" class="form-control selectStatusInFilter" :min="filters.start_fecha_reg"
                      :max="maxDate" name="createEnd" placeholder="Selecciona una fecha" v-model="filters.end_fecha_reg"/>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" sm="6" md="4" lg="4" xl="4">
                <b-row>
                  <b-col cols="6">
                      <p>NIF/ NIE/ PASAPORTE:</p>
                  </b-col>
                  <b-col cols="6">
                    <b-form-input id="filter-dni" type="text" v-model="filters.dni" label="Documento"/>
                  </b-col>
                </b-row>
              </b-col>
              <b-col cols="12" sm="6" md="4" lg="4" xl="4">
                <b-row>
                  <b-col cols="6">
                    <p class="">Estado:</p>
                  </b-col>
                  <b-col cols="6">
                    <b-form-select id="filter-status" ref="selectStatus" class="form-control selectStatusInFilter" v-model="filters.status" :options="filterStatusOptions"/>
                  </b-col>
                </b-row>
              </b-col>
              <b-col cols="12" sm="6" md="4" lg="4" xl="4">
                <b-row>
                  <b-col cols="6">
                    <p class="">Razón social:</p>
                  </b-col>
                  <b-col cols="6">
                    <b-form-input id="filter-social" type="text" v-model="filters.social" label="Razón Social"/>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
            <b-row>
              <b-col cols="12" sm="6" md="4" lg="4" xl="4">
                <b-row>
                  <b-col cols="6">
                    <p class="">CIF:</p>
                  </b-col>
                  <b-col cols="6">
                    <b-form-input id="filter-cif" type="text" v-model="filters.cif" label="CIF"/>
                  </b-col>
                </b-row>
              </b-col>
            </b-row>
          </b-col>
        </b-card-body>
        <div class="btnFiltrar" id="btnFiltrar">
          <b-row>
            <b-col cols="12">
              <b-button id="filter-btn" @click="$emit('on-filter-click')">Filtrar</b-button>
              <b-button id="erase-filter-btn" @click="$emit('on-borrar-click')">Borrar Filtros</b-button>
            </b-col>
          </b-row>
        </div>
      </b-collapse>
    </b-card>
  </div>
</template>
<script>
export default {
  name: 'contracts-filter',
  props: ['value'],
  data(){
    return{
      rol: null,
      filterVisible: true,
      filterStatusOptions: [],
      filterAgencyOptions: [],
      filters: {},
      maxDate: new Date(),
      token:'',
      refactorEnv:'',
      departamentos: ''
    }
  },
  created() {
    this.rol = this.$session.get('rol')
    if(this.$session.has("token")){ this.token = this.$session.get("token")}
    this.refactorEnv = this.$session.get("settings")
  },
  mounted() {
    this.buildStatusSelector()
  },
  computed: {
    filterAccordionBtnText() {
      return this.filterVisible ? '-' : '+';
    },
    contractMinEndDate() {
      return this.filters.end_registration_date ? this.filters.end_registration_date : this.maxDate;
    },
    signatureMinEndDate() {
      return this.filters.end_sign_date ? this.filters.end_sign_date : this.maxDate;
    }
  },
  methods: {
    async buildStatusSelector() {
      await this.$http.post(this.refactorEnv.getStatusList,{}, { headers: {
        'Authorization': this.token
      }}).then(response => {
        var aux = []
        response.body.status_list.forEach(function(value, index, array){
          aux.push({ "value" : value.Id,"text":value.Estado })
        });
        this.filterStatusOptions = aux;

      }).catch(error => {console.log(error)});
    },
    borrarFiltros() {
      this.filters = {}
      this.$emit('input', this.filters)
    }
  },
  watch: {
    filters: function(val) {
      this.$emit('input', this.filters)
    }
  }
}
</script>



// WEBPACK FOOTER //
// src/components/contracts/contracts-filter.vue